import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-c-product-list',
  templateUrl: './c-product-list.component.html',
  styleUrls: ['./c-product-list.component.css']
})
export class CProductListComponent implements OnInit {

  cProductList: any = []
  page: number = 0;
  count: number = 0;
  tableSize: number = 10;
  tableSizes: any = [3, 6, 9, 12];
  singleCproductMasterData: any = []
  first: number = 0;
  isLoading: any = false

  id: any
  searchKey: string = '';


  cid: any;
  form: any | FormGroup;
  addButton = false;
  formSubmitted = false;


  selectedUomId: any = "";
  uomDropdownList: any = [];

  actionControls: any = {
    isAdd: false,
    isView: false,
    isDelete: false,
    isModify: false
  }

  constructor(private fb: FormBuilder, private toastr: ToastrService, private generic_service: GenericService) { }

  ngOnInit(): void {


    let href: any = window.location.href;
    let messages = href.split('/')
    let action: any = this.generic_service.checkActionControls(messages[messages.length - 1])
    this.actionControls = action

    this.cid = sessionStorage.getItem('cid')
    this.form = this.fb.group({
      name: ['', [Validators.required]],
      description: [''],
      group: ['', [Validators.required]],
      price: ['', [Validators.required]],
      code: ['', [Validators.required]]
    })

    this.getAllUomMaster()
    this.getAllCProduct();
  }


  onTableDataChange(event: any) {
    this.page = event.page + 1;
    if (this.searchKey && this.searchKey.trim() !== '') {
      this.getCProductByWildSearch();
    } else {
      this.getAllCProduct();
    }
  }

  refreshAll() {
    this.searchKey = '';
    this.page = 1;
    this.getAllCProduct();
  }

  getCProductByWildSearch() {
    this.isLoading = true;
    this.page = 1;
    let pageNo = this.page > 0 ? this.page - 1 : 0;

    let body = {
      "key": this.searchKey,
      "pageNo": pageNo,
      "recordPerPage": this.tableSize,
      "cid": this.cid || sessionStorage.getItem('cid')
    };

    this.generic_service.getCProductMasterByWildSearch(body).subscribe(
      (response: any) => {
        console.log(response);
        let respData = response.response;
        this.cProductList = respData?.cProductMasterList || [];
        this.count = respData?.totalRecords;
        this.isLoading = false;
      },
      (error: any) => {
        console.error(error);
        this.isLoading = false;
      }
    );
  }

  getAllCProduct() {
    this.isLoading = true;
    let pageNo = this.page > 0 ? this.page - 1 : 0;

    this.generic_service.getAllcProductMasterWithPagination(pageNo, this.tableSize).subscribe(
      (response: any) => {
        console.log(response);
        let respData = response.response;
        this.cProductList = respData?.cProductMasterList || respData?.cproductMasterList || respData?.data || respData?.content || respData || [];
        this.count = respData?.totalRecords;
        this.isLoading = false;
      },
      (error: any) => {
        console.error(error);
        this.isLoading = false;
      }
    );
  }

  onRowClick(event: Event, id: any) {
    const target = event.target as HTMLElement;
    if (target.closest('.action-buttons')) {
      return;
    }
    this.getCproductMasterById(id);
    document.getElementById("openViewModalBtn")?.click();
  }

  getCproductMasterById(cProductId: any) {
    this.generic_service.getCproductMasterById(cProductId).subscribe(
      (res: any) => {
        console.log(res);

        this.setUomFromResponse(res.response);

        this.singleCproductMasterData = [];
        this.singleCproductMasterData.push(res.response);
        this.form.setValue({
          name: res.response.name,
          description: res.response.description || '',
          group: res.response.group,
          price: res.response.price,
          code: res.response.code,
        });
      },
      (err: any) => {
        console.log(err);
      }
    );
  }

  setUomFromResponse(resData: any) {
    this.selectedUomId = '';
    if (!resData) return;

    let supportedList = resData.supportedUOM || [];
    let defaultUom = supportedList.find((u: any) => u.isDefault == true) || supportedList[0];
    let uomName = defaultUom?.uomName || resData.uomName || resData.uom;
    let uomId = defaultUom?.uomId || defaultUom?.uomMasterId || resData.uomId || resData.uomMasterId;

    const findAndSet = () => {
      let matched = this.uomDropdownList.find((u: any) =>
        (uomId != null && uomId !== '' && (u.uomMasterId == uomId || u.uomId == uomId)) ||
        (uomName && u.uomName?.trim().toLowerCase() === uomName?.trim().toLowerCase())
      );
      if (matched) {
        this.selectedUomId = matched.uomMasterId;
      } else if (uomId != null && uomId !== '') {
        this.selectedUomId = uomId;
      }
    };

    if (this.uomDropdownList && this.uomDropdownList.length > 0) {
      findAndSet();
    } else {
      if (uomId != null && uomId !== '') {
        this.selectedUomId = uomId;
      }
      this.generic_service.getAllUomMaster().subscribe(
        (uomRes: any) => {
          this.uomDropdownList = uomRes.response || [];
          findAndSet();
        },
        (err: any) => {
          console.error(err);
        }
      );
    }
  }

  openAdd() {
    this.form.reset();
    this.selectedUomId = "";
    this.formSubmitted = false;
  }

  cancelModel() {
    document.getElementById("closeModalButton")?.click()
    document.getElementById("closeModalButton1")?.click()
    document.getElementById("closeAdd")?.click()
    document.getElementById("closeEdit")?.click()
  }

  deleteCproduct(id: any) {
    this.id = id
  }

  deleteCproductMaster() {
    this.generic_service.deleteCproductMaster(this.id).subscribe(
      (res: any) => {
        console.log(res)
        this.getAllCProduct()
        this.toastr.success("Successfully Deleted")
        this.cancelModel()
      },
      (err: any) => {
        console.log(err)
        this.toastr.error(err.errors[0].description)
      }
    )
  }



  getAllUomMaster() {
    this.generic_service.getAllUomMaster().subscribe(
      (res: any) => {
        console.log(res)
        this.uomDropdownList = res.response
      },
      (err: any) => {
        console.log(err)
      }
    )
  }


  addCProduct() {
    this.formSubmitted = true;
    if (!this.form.valid || !this.selectedUomId) {
      this.toastr.error('Please fill all required fields');
      console.log(this.form.value)
      return
    }
    this.addButton = true;

    let supportedUOM = [];
    let selectedUomObj = this.uomDropdownList.find((u: any) => u.uomMasterId == this.selectedUomId);
    if (selectedUomObj) {
      supportedUOM.push({
        "uomId": selectedUomObj.uomMasterId,
        "uomName": selectedUomObj.uomName,
        "price": Number(this.form.get('price').value),
        "discountedPrice": 0,
        "quantity": 0,
        "cid": 0,
        "isDefault": true
      });
    }

    let body = {
      "version": 0,
      "isActive": true,
      "code": String(this.form.get('code').value),
      "description": String(this.form.get('description').value),
      "name": String(this.form.get('name').value),
      "group": String(this.form.get('group').value),
      "status": "active",
      "price": Number(this.form.get('price').value),
      "cid": Number(this.cid),
      "supportedUOM": supportedUOM,
      "cproductId": 0
    }
    console.log(body)
    this.generic_service.addCProduct(body).subscribe(
      (response: any) => {
        console.log(response)
        this.form.reset()
        this.cancelModel()
        this.toastr.success(response.message)
        this.addButton = false;
        this.formSubmitted = false;
        this.selectedUomId = "";
        this.getAllCProduct();

      },
      (error: any) => {
        console.log(error)
        this.toastr.error(error.error.errors[0].description);
        this.addButton = false;
      }
    )
  }




  editCProduct() {
    this.formSubmitted = true;
    if (!this.form.valid || !this.selectedUomId) {
      this.toastr.error('Please fill all required fields');
      console.log(this.form.value);
      return;
    }

    let supportedUOM = [];
    let selectedUomObj = this.uomDropdownList.find((u: any) => u.uomMasterId == this.selectedUomId);
    if (selectedUomObj) {
      supportedUOM.push({
        "uomId": selectedUomObj.uomMasterId,
        "uomName": selectedUomObj.uomName,
        "price": Number(this.form.get('price').value),
        "discountedPrice": 0,
        "quantity": 0,
        "cid": 0,
        "isDefault": true
      });
    }

    let body = {
      "version": 0,
      "isActive": true,
      "code": String(this.form.get('code').value),
      "description": String(this.form.get('description').value),
      "name": String(this.form.get('name').value),
      "group": String(this.form.get('group').value),
      "status": "active",
      "price": Number(this.form.get('price').value),
      "supportedUOM": supportedUOM,
      "cid": this.singleCproductMasterData[0].cid,
      "id": this.singleCproductMasterData[0].id,
      "cProductId": this.singleCproductMasterData[0].cProductId
    }

    console.log(body);

    this.generic_service.editCProduct(body).subscribe(
      (response: any) => {
        console.log(response)
        this.form.reset()
        this.cancelModel()
        this.toastr.success(response.message)
        this.addButton = false;
        this.formSubmitted = false;
        this.getAllCProduct();

      },
      (error: any) => {
        console.log(error)
        this.toastr.error(error.error.errors[0].description);
        this.addButton = false;
      }
    )

  }

}
